module.exports = __webpack_public_path__ + "img/IMG_4436.8071b1e4.jpg";